import { Component, OnInit } from '@angular/core';
import{ApiService} from '../../services/api.service';
import { Router, ActivatedRoute} from '@angular/router';
import { ModalController } from '@ionic/angular';
import { DetailEksisPage } from '../detail-eksis/detail-eksis.page';

@Component({
  selector: 'app-eksis-kategori',
  templateUrl: './eksis-kategori.page.html',
  styleUrls: ['./eksis-kategori.page.scss'],
})
export class EksisKategoriPage implements OnInit {

  constructor(
  private api:ApiService,
  private route: ActivatedRoute,
  private modalCtrl:ModalController, 
  ) { }
  tag:any;
  ngOnInit() {
  	 this.tag=this.route.snapshot.paramMap.get('tag');
  	 this.getPosting(this.tag);
  }
  keyApp:any=localStorage.getItem('keyApp');
  postingData:any=[];
  page:number=1;
  loading:boolean;
  getPosting(tag)
  {
  		this.loading=true;
  		this.api.data('eksis/all?tag='+tag+'&key_app='+this.keyApp+'&page='+this.page,'get','').subscribe(data=>{  
  			this.loading=false;			
  			this.page=this.page+1;
  			this.parseData(data);
  		})
  }
  parseData(data)
  {
  		for(var i=0; i<data.length; i++)
  		{
  			this.postingData.push(data[i]);
  		}
  }
   async detailEksis(data) {
    const modal = await this.modalCtrl.create({
      component: DetailEksisPage,
      componentProps: {
        posting:data
      }
    });
    return await modal.present();
  }

}
